import { IconButton, Tooltip } from "@mui/material";
import React from "react";

import { useTranslation } from "react-i18next";
import { resetRotation } from "../../../../../services/MapCore/MapService";

export const ResetRotationButton = ({ map }) => {
  const { t } = useTranslation("main");

  return (
    <Tooltip title={t("reset_rotation")}>
      <IconButton onClick={() => resetRotation({ map })} className="mapButton">
        <img
          src={"images/icons/north-symbol-icon.svg"}
          style={{ width: "100%", height: "100%" }}
        />
      </IconButton>
    </Tooltip>
  );
};
